module.exports = __webpack_public_path__ + "static/media/Macbook Quickfind.5c23e140.png";